module.exports = __webpack_public_path__ + "img/startup.3dd13f22.png";